import React from 'react';
import LegalDocumentPage from '@/components/LegalDocumentPage';

export default function Terms() {
    return <LegalDocumentPage docType="terms" />;
}
